/* Planet Tree · Inhaltsseiten: Lightbox fuer Fotos, Suche in Fragen, "alle oeffnen". ES5. Claude 23.10.2026 */
(function () {
  "use strict";
  var root = document.querySelector(".ptp");
  if (!root) return;
  /* Lightbox: Bilder in .ptp-gallery oder mit data-ptp-zoom */
  var imgs = root.querySelectorAll(".ptp-gallery img, img[data-ptp-zoom], a[data-ptp-zoom]");
  var list = [];
  for (var i = 0; i < imgs.length; i++) if (!/(^|\s)pta2-/.test(imgs[i].className || "")) list.push(imgs[i]); /* Foersterin Anne (pt-anne-say) nicht in die Lightbox */
  function big(el) {
    var src = el.getAttribute("data-ptp-big") || (el.tagName === "A" ? el.getAttribute("href") : (el.currentSrc || el.src));
    return String(src || "").replace(/([?&])width=\d+/, "$1width=1800");
  }
  function cap(el) {
    var f = el.closest ? el.closest("figure") : null, c = f ? f.querySelector("figcaption") : null;
    return c ? c.textContent : (el.getAttribute("alt") || "");
  }
  function open(idx) {
    var cur = idx, last = document.activeElement;
    var ov = document.createElement("div"); ov.className = "ptp-lb"; ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true");
    var im = document.createElement("img"), p = document.createElement("p");
    var x = document.createElement("button"); x.type = "button"; x.className = "ptp-lb-x"; x.setAttribute("aria-label", "Schließen"); x.textContent = "×";
    ov.appendChild(im); ov.appendChild(p); ov.appendChild(x);
    var prev = null, next = null;
    if (list.length > 1) {
      prev = document.createElement("button"); prev.type = "button"; prev.className = "ptp-lb-nav ptp-lb-prev"; prev.setAttribute("aria-label", "Vorheriges Bild"); prev.textContent = "‹";
      next = document.createElement("button"); next.type = "button"; next.className = "ptp-lb-nav ptp-lb-next"; next.setAttribute("aria-label", "Nächstes Bild"); next.textContent = "›";
      ov.appendChild(prev); ov.appendChild(next);
    }
    function show(n) { cur = (n + list.length) % list.length; im.src = big(list[cur]); im.alt = list[cur].getAttribute("alt") || ""; p.textContent = cap(list[cur]); p.style.display = p.textContent ? "" : "none"; }
    function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); document.documentElement.style.overflow = ""; document.removeEventListener("keydown", key, false); try { if (last) last.focus(); } catch (e) {} }
    function key(e) { if (e.keyCode === 27) close(); else if (e.keyCode === 37 && prev) show(cur - 1); else if (e.keyCode === 39 && next) show(cur + 1); }
    ov.addEventListener("click", function (e) {
      if (e.target === prev) { e.stopPropagation(); show(cur - 1); return; }
      if (e.target === next) { e.stopPropagation(); show(cur + 1); return; }
      if (e.target === im && next) { show(cur + 1); return; }
      close();
    }, false);
    var sx = 0;
    ov.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, false);
    ov.addEventListener("touchend", function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50 && next) { show(cur + (dx < 0 ? 1 : -1)); } }, false);
    document.addEventListener("keydown", key, false);
    document.documentElement.style.overflow = "hidden";
    show(idx);
    document.body.appendChild(ov);
    x.focus();
  }
  for (var j = 0; j < list.length; j++) (function (el, n) {
    el.addEventListener("click", function (e) { e.preventDefault(); open(n); }, false);
    if (el.tagName === "IMG") { el.setAttribute("tabindex", "0"); el.addEventListener("keydown", function (e) { if (e.keyCode === 13) open(n); }, false); }
  })(list[j], j);

  /* Fragen: Suche + Themen */
  var search = root.querySelector(".ptp-search input");
  var items = root.querySelectorAll(".ptp-faq details");
  var empty = root.querySelector(".ptp-empty");
  var chips = root.querySelectorAll("[data-ptp-topic]");
  var topic = "";
  function norm(s) { return String(s || "").toLowerCase().replace(/ä/g, "a").replace(/ö/g, "o").replace(/ü/g, "u").replace(/ß/g, "ss"); }
  function filter() {
    var q = search ? norm(search.value).replace(/^\s+|\s+$/g, "") : "", n = 0;
    for (var k = 0; k < items.length; k++) {
      var d = items[k], t = d.getAttribute("data-topic") || "";
      var hit = (!topic || t === topic) && (!q || norm(d.textContent).indexOf(q) >= 0);
      d.style.display = hit ? "" : "none";
      if (hit) n++;
      if (q && hit) d.open = true;
    }
    var groups = root.querySelectorAll(".ptp-faq-group");
    for (var g = 0; g < groups.length; g++) groups[g].style.display = (q || topic) ? "none" : "";
    if (empty) empty.style.display = n ? "none" : "block";
  }
  if (search) search.addEventListener("input", filter, false);
  for (var c = 0; c < chips.length; c++) (function (b) {
    b.addEventListener("click", function () {
      topic = b.getAttribute("data-ptp-topic") || "";
      for (var m = 0; m < chips.length; m++) { var onn = chips[m] === b; chips[m].className = onn ? "is-on" : ""; chips[m].setAttribute("aria-pressed", onn ? "true" : "false"); }
      filter();
    }, false);
  })(chips[c]);
  var all = root.querySelector("[data-ptp-openall]");
  if (all) all.addEventListener("click", function () {
    var anyClosed = false, k;
    for (k = 0; k < items.length; k++) if (!items[k].open && items[k].style.display !== "none") anyClosed = true;
    for (k = 0; k < items.length; k++) if (items[k].style.display !== "none") items[k].open = anyClosed;
    all.textContent = anyClosed ? "Alle schließen" : "Alle öffnen";
  }, false);
  /* Anker aus der Adresse: Frage direkt oeffnen */
  if (location.hash) { try { var t = root.querySelector(location.hash); if (t && t.tagName === "DETAILS") t.open = true; } catch (e) {} }
})();
/* Presse: nach Medium filtern; Kontaktformular: Erfolgsmeldung */
(function () {
  var bs = document.querySelectorAll("[data-ptp-medium]"), items = document.querySelectorAll(".ptp-press-item");
  for (var i = 0; i < bs.length; i++) (function (b) {
    b.addEventListener("click", function () {
      var m = b.getAttribute("data-ptp-medium");
      for (var k = 0; k < bs.length; k++) bs[k].className = bs[k] === b ? "is-on" : "";
      for (var j = 0; j < items.length; j++) items[j].style.display = !m || items[j].getAttribute("data-medium") === m ? "" : "none";
    }, false);
  })(bs[i]);
  if (/[?&]contact_posted=true/.test(location.search)) {
    var ok = document.querySelector(".ptp-form .ptp-ok");
    if (ok) { ok.style.display = "block"; try { ok.scrollIntoView({ block: "center" }); } catch (e) {} }
  }
})();
(function () {
  var b = document.querySelectorAll(".ptp-press-open");
  for (var i = 0; i < b.length; i++) b[i].addEventListener("click", function () {
    var it = this.parentNode && this.parentNode.parentNode, im = it ? it.querySelector("img[data-ptp-zoom]") : null;
    if (im) im.click();
  }, false);
})();
/* CO2-Rechner */
(function () {
  var f = document.querySelector("[data-ptp-co2]"); if (!f) return;
  var mode = f.querySelector("[data-co2-mode]"), km = f.querySelector("[data-co2-km]"), pp = f.querySelector("[data-co2-p]"), out = f.querySelector("[data-co2-out]"), unit = f.querySelector("[data-co2-unit]");
  function calc() {
    var r = parseFloat(mode.value) || 0.1, k = Math.max(0, parseFloat(km.value) || 0), p = r > 0.2 ? Math.max(1, parseInt(pp.value, 10) || 1) : 1;
    var t = k / 1000 * r * p, n = Math.max(1, Math.ceil(t));
    out.textContent = t < 1 ? "1" : String(n);
    unit.textContent = (t < 1 || n === 1) ? "Baum" : "Bäume";
    pp.parentNode && (pp.disabled = r < 0.2);
  }
  mode.addEventListener("change", calc, false); km.addEventListener("input", calc, false); pp.addEventListener("input", calc, false);
  calc();
})();
/* B2B: Zugang anlegen (gleiche Pruefung wie bisher) und Info-PDF-Anfrage */
(function () {
  var f = document.querySelector("form[data-ptp-b2b]");
  if (f) {
    var url = f.getAttribute("data-ptp-b2b"), st = f.querySelector(".ptp-status"), btn = f.querySelector("button[type=submit]"), fp = f.hasAttribute("data-ptp-fp");
    function v(n) { var e = f.querySelector('[name="' + n + '"]'); return e ? String(e.value || "").replace(/^\s+|\s+$/g, "") : ""; }
    function msg(t, tone) { st.textContent = t || ""; if (tone) st.setAttribute("data-tone", tone); else st.removeAttribute("data-tone"); }
    var ERR = { "email_already_used_as_additional_portal_user": "Diese E-Mail-Adresse ist bereits als zusätzlicher Benutzer in einem anderen B2B-Konto hinterlegt." };
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var d = { company_name: v("company_name"), contact_name: v("contact_name"), email: v("email"), street: v("street"), zip: v("zip"), city: v("city"), country: v("country"), phone: v("phone"), business_confirmed: !!(f.querySelector('[name="business_confirmed"]') || {}).checked, website: v("website") };
      var miss = !d.company_name ? "Bitte die Firma eintragen." : !d.contact_name ? "Bitte einen Ansprechpartner angeben." : (d.email.indexOf("@") < 0 ? "Bitte eine gültige E-Mail-Adresse angeben." : !d.street ? "Bitte Straße und Hausnummer angeben." : !d.zip ? "Bitte die PLZ angeben." : !d.city ? "Bitte den Ort angeben." : !d.country ? "Bitte das Land angeben." : !d.business_confirmed ? "Bitte bestätigt, dass ihr geschäftlich bzw. als Unternehmen handelt." : "");
      if (miss) { msg(miss, "err"); return; }
      btn.disabled = true; msg("Zugang wird angelegt …", "");
      var x = new XMLHttpRequest();
      x.open("POST", url, true); x.setRequestHeader("Content-Type", "application/json"); x.timeout = 45000;
      x.onload = function () {
        btn.disabled = false;
        var r = {}; try { r = JSON.parse(x.responseText) || {}; } catch (er) {}
        if (fp && (x.status < 200 || x.status >= 300) && typeof r.detail === "string" && r.detail && r.detail.length > 12) { msg(r.detail, "err"); return; }
        if (x.status < 200 || x.status >= 300) {
          var code = String(r.detail || r.reason || "");
          msg(ERR[code] || (code.indexOf("shopify_customer") === 0 ? "Das B2B-Konto konnte gerade nicht vollständig angelegt werden. Bitte schreibt uns kurz an kontakt@planet-tree.de." : "Die Anmeldung konnte gerade nicht abgeschlossen werden. Bitte schreibt uns sonst kurz an kontakt@planet-tree.de."), "err");
          return;
        }
        f.reset(); var c = f.querySelector('[name="country"]'); if (c) c.value = "Deutschland";
        if (fp) { msg(r.existing ? "Zu dieser E-Mail gibt es schon ein Firmenkonto – der Anmelde-Link ist unterwegs. 📬" : "Geschafft! 🎉 Schaut in euer Postfach: Mit dem Anmelde-Link seid ihr in einer Minute im Firmenportal.", "ok"); try { (window.dataLayer = window.dataLayer || []).push({ event: "b2b_signup", existing: !!r.existing }); } catch (er2) {} return; }
        msg(r.existing ? "Der Zugang war bereits vorhanden. Die Login-E-Mail wurde erneut versendet." : "Vielen Dank. Ihr erhaltet jetzt eine E-Mail mit dem Login-Link.", "ok");
      };
      x.onerror = x.ontimeout = function () { btn.disabled = false; msg("Die Verbindung ist gerade langsam. Bitte versucht es noch einmal.", "err"); };
      x.send(JSON.stringify(fp ? { company: d.company_name, name: d.contact_name, email: d.email, street: d.street, zip: d.zip, city: d.city, country: d.country || "Deutschland",
        phone: d.phone, business: d.business_confirmed, website: d.website, source: "firmenseite" } : d));
    }, false);
  }
  var p = document.querySelector("form[data-ptp-infopdf]");
  if (p) {
    p.addEventListener("submit", function () {
      var g = function (n) { var e = p.querySelector('[name="' + n + '"]'); return e ? e.value : ""; };
      p.querySelector('[name="contact[body]"]').value = "Bitte sendet mir das B2B Info-PDF (Konditionen).\nName: " + g("contact[name]") + "\nFirma: " + g("contact[company]") + "\nE-Mail: " + g("contact[email]") + "\nQuelle: /pages/unternehmen";
    }, false);
    if (/[?&]contact_posted=true/.test(location.search) && location.hash === "#info") { var ok = p.querySelector(".ptp-ok"); if (ok) ok.style.display = "block"; }
  }
})();
/* Partner: neueste Pflanzungen (Storefront-Metaobjekte, wie bisher) + Verzeichnis-Suche */
(function () {
  var box = document.querySelector("[data-ptp-live]"); if (!box) return;
  var TOKEN = "243781c2a1c6b53339c14b6b1a624cb5", LIMIT = 8;
  function gql(q, v, cb) {
    var x = new XMLHttpRequest();
    x.open("POST", "/api/2024-07/graphql.json", true);
    x.setRequestHeader("Content-Type", "application/json"); x.setRequestHeader("X-Shopify-Storefront-Access-Token", TOKEN); x.setRequestHeader("Accept", "application/json");
    x.timeout = 20000;
    x.onload = function () { var r = null; try { r = JSON.parse(x.responseText); } catch (e) {} cb(r); };
    x.onerror = x.ontimeout = function () { cb(null); };
    x.send(JSON.stringify({ query: q, variables: v || {} }));
  }
  function fields(n) { var m = {}, f = n.fields || []; for (var i = 0; i < f.length; i++) if (f[i] && f[i].key) m[f[i].key] = f[i].value; return m; }
  function esc(s) { return String(s || "").replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function truthy(x) { return /^(true|1|yes|ja|y)$/i.test(String(x || "").replace(/^\s+|\s+$/g, "")); }
  function noshow(a, b) { return /noshow/i.test(String(a || "")) || /noshow/i.test(String(b || "")); }
  function ts(n) { var m = fields(n), s = String(m.ts || n.updatedAt || ""), t = Date.parse(s); if (isNaN(t)) { var d = /^(\d{1,2})\.(\d{1,2})\.(\d{4})/.exec(s); if (d) t = Date.UTC(+d[3], +d[2] - 1, +d[1]); } if (isNaN(t)) t = Date.parse(n.updatedAt); return isNaN(t) ? 0 : t; }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }
  var Q1 = "query($first:Int!,$after:String){events:metaobjects(type:\"planting_event\",first:$first,after:$after,sortKey:\"updated_at\",reverse:true){nodes{id updatedAt fields{key value}} pageInfo{hasNextPage endCursor}}}";
  var Q2 = "query($first:Int!){anns:metaobjects(type:\"partner_announcement\",first:$first,sortKey:\"updated_at\",reverse:true){nodes{id updatedAt fields{key value}}}}";
  var ulB = box.querySelector("[data-ptp-live-b2b]"), ulP = box.querySelector("[data-ptp-live-partner]");
  function fill(ul, list, ico, sub) {
    if (!ul) return;
    ul.innerHTML = list.length ? list.map(function (it) { return '<li><span class="ptp-live-ico" aria-hidden="true">' + ico + "</span><span><b>" + esc(it.company) + "</b>" + (sub ? "<small>" + sub(it) + "</small>" : "") + "</span></li>"; }).join("") : '<li><span class="ptp-live-ico">' + ico + "</span><span>Noch keine Einträge</span></li>";
  }
  var all = [];
  function loadEvents(after, n) {
    gql(Q1, { first: 150, after: after || null }, function (r) {
      var c = r && r.data && r.data.events;
      if (c && c.nodes) all = all.concat(c.nodes);
      if (c && c.pageInfo && c.pageInfo.hasNextPage && n < 3) { loadEvents(c.pageInfo.endCursor, n + 1); return; }
      all.sort(function (a, b) { return ts(b) - ts(a); });
      var out = [];
      for (var i = 0; i < all.length && out.length < LIMIT; i++) {
        var m = fields(all[i]), co = String(m.company || "").replace(/^\s+|\s+$/g, "");
        if (!co || noshow(co, m.noshow) || truthy(m.noshow) || /^#?\d{3,}$/.test(String(m.order || ""))) continue;
        var q = Math.max(1, parseInt(String(m.trees || "").replace(/[^\d]/g, ""), 10) || 1);
        out.push({ company: co, qty: q });
      }
      fill(ulB, out, "🌳", function (it) { return fmt(it.qty) + (it.qty === 1 ? " Baum" : " Bäume"); });
    });
  }
  function start() {
    loadEvents(null, 0);
    gql(Q2, { first: 120 }, function (r) {
      var ns = (r && r.data && r.data.anns && r.data.anns.nodes) || [], out = [];
      for (var i = 0; i < ns.length && out.length < LIMIT; i++) { var m = fields(ns[i]), co = String(m.company || "").replace(/^\s+|\s+$/g, ""); if (!co || noshow(co, m.noshow) || truthy(m.noshow)) continue; out.push({ company: co }); }
      fill(ulP, out, "🎉", null);
    });
  }
  if (window.IntersectionObserver) { var io = new IntersectionObserver(function (es) { if (es[0] && es[0].isIntersecting) { io.disconnect(); start(); } }, { threshold: 0.05 }); io.observe(box); } else start();
})();
(function () {
  var inp = document.querySelector("[data-ptp-dirsearch]"); if (!inp) return;
  var groups = document.querySelectorAll(".ptp-dir-group"), empty = document.querySelector("[data-ptp-dirempty]");
  function norm(s) { return String(s || "").toLowerCase().replace(/ä/g, "a").replace(/ö/g, "o").replace(/ü/g, "u").replace(/ß/g, "ss"); }
  inp.addEventListener("input", function () {
    var q = norm(inp.value).replace(/^\s+|\s+$/g, ""), any = 0;
    for (var g = 0; g < groups.length; g++) {
      var li = groups[g].querySelectorAll("li"), n = 0;
      for (var i = 0; i < li.length; i++) { var hit = !q || norm(li[i].textContent).indexOf(q) >= 0; li[i].style.display = hit ? "" : "none"; if (hit) n++; }
      groups[g].style.display = n ? "" : "none"; any += n;
    }
    if (empty) empty.style.display = any ? "none" : "block";
  }, false);
})();
/* Live-Baumzahl (verifizierter Zaehler aus dem Shop) in [data-ptp-trees-out] einsetzen */
(function () {
  var r = document.querySelector(".ptp[data-ptp-trees]"); if (!r) return;
  var n = parseInt(r.getAttribute("data-ptp-trees"), 10); if (!(n > 0)) return;
  var t = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  var els = document.querySelectorAll("[data-ptp-trees-out]");
  for (var i = 0; i < els.length; i++) els[i].textContent = t + (els[i].getAttribute("data-suffix") || "");
})();
/* Baumgeschenk: Zertifikat-Code pruefen und zur Zertifikatsseite */
(function () {
  var f = document.querySelector("form[data-ptp-codeform]"); if (!f) return;
  var inp = f.querySelector("input"), err = f.querySelector(".ptp-err");
  function norm(v) { return String(v || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); }
  inp.addEventListener("input", function () { var v = norm(inp.value); if (v !== inp.value) inp.value = v; if (err) err.style.display = "none"; }, false);
  f.addEventListener("submit", function (e) {
    e.preventDefault();
    var v = norm(inp.value);
    if (!/^[A-Z0-9]{6,12}$/.test(v)) { if (err) err.style.display = "block"; inp.focus(); return; }
    location.href = "/pages/zertifikat?code=" + encodeURIComponent(v);
  }, false);
})();
/* Zertifikatsseite: ohne Code -> Eingabeformular; Ueberschriften in der Sprache des Zertifikats */
(function () {
  var root = document.querySelector("[data-ptp-cert]"); if (!root) return;
  var q = String(location.search || "").replace(/^\?/, ""), has = false;
  if (/(^|&)code=[^&]+/i.test(q)) has = true; else if (/^[A-Za-z0-9]{8}$/.test(q.split("&")[0])) has = true;
  if (!has) {
    var nc = root.querySelector("[data-ptp-cert-nocode]"), mn = root.querySelector("[data-ptp-cert-main]");
    if (nc) nc.style.display = ""; if (mn) mn.style.display = "none"; root.className += " is-nocode";
  } else if (window.MutationObserver) {
    /* Code unbekannt oder nicht ladbar: freundlicher Hinweis + Eingabefeld statt technischer Fehlermeldung */
    var meta = document.getElementById("pt-cert-meta");
    if (meta) new MutationObserver(function (m, obs) {
      if (!meta.querySelector('dd[style*="grid-column"]')) return;
      obs.disconnect();
      var nc2 = root.querySelector("[data-ptp-cert-nocode]"), mn2 = root.querySelector("[data-ptp-cert-main]");
      if (!nc2) return;
      var h = nc2.querySelector("h2"), p = nc2.querySelector(".ptp-head p");
      if (h) h.textContent = "Dieser Code wurde nicht gefunden.";
      if (p) p.textContent = "Bitte prüfe die Schreibweise – der Code steht auf deinem Zertifikat unter dem QR-Code. Wenn es trotzdem nicht klappt, schreib uns kurz an kontakt@planet-tree.de.";
      var inp = nc2.querySelector("input"); var mc = /(?:^|&)code=([^&]+)/i.exec(String(location.search).replace(/^\?/, ""));
      if (inp && mc) inp.value = decodeURIComponent(mc[1]).toUpperCase();
      nc2.style.display = ""; if (mn2) mn2.style.display = "none"; root.className += " is-nocode";
    }).observe(meta, { childList: true });
  }
  var T = {
    "Zertifikats-Informationen": ["de", "Hier wächst dein Geschenk.", "Ein Geschenk voller Leben. Entdecke die Baumart, den Wald und den Pflanzort, die zu deinem Zertifikat gehören."],
    "Certificate information": ["en", "Your gift grows here.", "A gift full of life. Discover the tree species, forest and planting location linked to your certificate."],
    "Información del certificado": ["es", "Aquí crece tu regalo.", "Un regalo lleno de vida. Descubre la especie, el bosque y el lugar de plantación de tu certificado."],
    "Informations sur le certificat": ["fr", "Ton cadeau grandit ici.", "Un cadeau plein de vie. Découvre l’essence, la forêt et le lieu de plantation de ton certificat."],
    "Sertifika bilgileri": ["tr", "Hediyen burada büyüyor.", "Hayat dolu bir hediye. Sertifikanla bağlantılı ağaç türünü, ormanı ve dikim yerini keşfet."]
  };
  var I = {
    en: { next_h: "What happens next with your tree", t1h: "Planted by the forestry office", t1p: "Official state and municipal forests plant in spring and autumn – suited to the site and as part of a healthy mixed forest.", t2h: "Reports from the forest", t2p: "After every planting we share photos and figures from the sites, so you can see your forest grow.", t2a: "Planting sites & reports", t3h: "Visit your forest", t3p: "Many sites are next to walking trails. With the coordinates above you can easily find the planting site.", cta_e: "Your gift takes root", cta_h: "Who should the next tree grow for?", cta_p: "Create a personal tree certificate with a name and dedication – planted in a German forest.", cta_b: "Give a tree · from €15", cta_b2: "About Planet Tree" },
    es: { next_h: "Qué pasa ahora con tu árbol", t1h: "Plantado por la oficina forestal", t1p: "Bosques públicos oficiales plantan en primavera y otoño, adaptado al terreno y como parte de un bosque mixto sano.", t2h: "Informes desde el bosque", t2p: "Tras cada plantación compartimos fotos y datos de las parcelas para que veas crecer tu bosque.", t2a: "Lugares e informes", t3h: "Visita tu bosque", t3p: "Muchas parcelas están junto a senderos. Con las coordenadas de arriba encontrarás fácilmente el lugar.", cta_e: "Tu regalo echa raíces", cta_h: "¿Para quién crecerá el próximo árbol?", cta_p: "Crea un certificado personal con nombre y dedicatoria, plantado en un bosque alemán.", cta_b: "Regalar un árbol · desde 15 €", cta_b2: "Sobre Planet Tree" },
    fr: { next_h: "La suite pour ton arbre", t1h: "Planté par l’office forestier", t1p: "Des forêts publiques officielles plantent au printemps et à l’automne – adapté au terrain, au sein d’une forêt mixte saine.", t2h: "Reportages de la forêt", t2p: "Après chaque plantation, nous partageons photos et chiffres des parcelles pour que tu voies ta forêt grandir.", t2a: "Lieux & reportages", t3h: "Visite ta forêt", t3p: "Beaucoup de parcelles longent des chemins de promenade. Grâce aux coordonnées ci-dessus, tu trouves facilement le lieu.", cta_e: "Ton cadeau prend racine", cta_h: "Pour qui poussera le prochain arbre ?", cta_p: "Crée un certificat personnel avec un nom et une dédicace – planté dans une forêt allemande.", cta_b: "Offrir un arbre · dès 15 €", cta_b2: "À propos de Planet Tree" },
    tr: { next_h: "Ağacınla bundan sonra neler olacak", t1h: "Orman idaresi tarafından dikildi", t1p: "Resmî devlet ve belediye ormanları ilkbahar ve sonbaharda, alana uygun ve sağlıklı bir karma ormanın parçası olarak diker.", t2h: "Ormandan raporlar", t2p: "Her dikimden sonra alanlardan fotoğraf ve rakamlar paylaşırız – ormanının büyümesini izle.", t2a: "Dikim yerleri ve raporlar", t3h: "Ormanını ziyaret et", t3p: "Birçok alan yürüyüş yollarının yanında. Yukarıdaki koordinatlarla dikim yerini kolayca bulursun.", cta_e: "Hediyen kök salıyor", cta_h: "Sıradaki ağaç kimin için büyüsün?", cta_p: "İsim ve ithafla kişisel bir ağaç sertifikası oluştur – Almanya’da bir ormana dikilir.", cta_b: "Ağaç hediye et · 15 €’dan", cta_b2: "Planet Tree hakkında" }
  };
  var rib = root.querySelector(".pt-hero .pt-ribbon__text"), h1 = root.querySelector("[data-ptp-cert-title]"), lead = root.querySelector("[data-ptp-cert-lead]"), last = "";
  function apply() {
    var t = rib ? String(rib.textContent || "").replace(/^\s+|\s+$/g, "") : "";
    if (t === last || !T[t]) return; last = t;
    var c = T[t]; if (h1) h1.textContent = c[1]; if (lead) lead.textContent = c[2];
    root.setAttribute("lang", c[0]);
    var d = I[c[0]]; if (!d) return;
    var els = root.querySelectorAll("[data-ptp-i18n]");
    for (var i = 0; i < els.length; i++) { var k = els[i].getAttribute("data-ptp-i18n"); if (d[k]) els[i].textContent = d[k]; }
  }
  if (rib && window.MutationObserver) new MutationObserver(apply).observe(rib, { childList: true, characterData: true, subtree: true });
  var n = 0, iv = setInterval(function () { apply(); if (++n > 20) clearInterval(iv); }, 500);
})();
/* Zertifikatsseite: lange Baumart-/Forsttexte hinter "Mehr erfahren" */
(function () {
  var root = document.querySelector("[data-ptp-cert]"); if (!root || !window.MutationObserver) return;
  var L = { de: "Mehr erfahren", en: "Learn more", es: "Más información", fr: "En savoir plus", tr: "Daha fazla bilgi" };
  function wrap(box) {
    if (!box || box.querySelector("details")) return;
    var kids = [], n = box.firstChild, first = null;
    while (n) { if (n.nodeType === 1) { if (!first && n.tagName === "P") first = n; else if (first) kids.push(n); } n = n.nextSibling; }
    if (!first || !kids.length) return;
    var d = document.createElement("details"), s = document.createElement("summary");
    s.textContent = L[root.getAttribute("lang")] || L.de; d.appendChild(s);
    for (var i = 0; i < kids.length; i++) d.appendChild(kids[i]);
    box.appendChild(d);
  }
  var ids = ["pt-spec-text", "pt-forest-text"];
  for (var i = 0; i < ids.length; i++) (function (el) {
    if (!el) return;
    new MutationObserver(function () { wrap(el); }).observe(el, { childList: true });
    wrap(el);
  })(document.getElementById(ids[i]));
})();
/* Rechtliche Seiten: Inhaltsverzeichnis aus den h2 bauen, falls keins vorhanden */
(function () {
  var a = document.querySelector("[data-ptp-legal]"); if (!a) return;
  var hs = a.querySelectorAll("h2"); if (hs.length < 4) return;
  for (var k = 0; k < a.children.length; k++) { if (a.children[k].tagName === "OL") return; if (a.children[k].tagName === "H2") break; }
  var ol = document.createElement("ol"), t = document.createElement("p");
  t.className = "ptp-toc-h"; t.innerHTML = "<strong>Inhalt</strong>";
  for (var i = 0; i < hs.length; i++) {
    if (!hs[i].id) hs[i].id = "abschnitt-" + (i + 1);
    var li = document.createElement("li"), l = document.createElement("a");
    l.href = "#" + hs[i].id; l.textContent = String(hs[i].textContent || "").replace(/^\s*\d+[.)]\s*/, "");
    li.appendChild(l); ol.appendChild(li);
  }
  a.insertBefore(ol, hs[0]); a.insertBefore(t, ol);
})();
